import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import SiteTracking from '@/layout/components/SiteTracking';
import enMessages from '@/translations/en.json';
import App from './App';
import 'semantic-ui-css/semantic.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@/assets/scss/default.scss';

const AppWrapper = ({ store }) => (
  <IntlProvider locale="en" messages={enMessages}>
    <Provider store={store}>
      <SiteTracking>
        <App store={store} />
      </SiteTracking>
    </Provider>
  </IntlProvider>
);

export default AppWrapper;
